﻿(() => {
  if (window.pmwOfferPdpReady) return;
  window.pmwOfferPdpReady = true;
  const instances = new Map();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pmw-offer-pdp]').forEach(root => {
      if (instances.has(root)) return;
      const primary = root.querySelector('[data-pmw-primary-cta]');
      const bar = root.querySelector('[data-pmw-offer-sticky]');
      if (!primary || !bar) return;
      const control = primary.cloneNode(true);
      control.removeAttribute('id');
      control.removeAttribute('data-pmw-primary-cta');
      if (control.dataset.pmwEvent) {
        control.dataset.pmwCtaId = 'pdp_sticky';
        control.dataset.pmwCtaLocation = 'pdp_sticky';
      }
      control.insertAdjacentHTML('afterbegin', '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/></svg>');
      bar.querySelector('[data-pmw-sticky-action]').replaceChildren(control);
      const price = root.querySelector('.room-product__price');
      const priceTarget = bar.querySelector('[data-pmw-sticky-price]');
      if (price) {
        const label = price.querySelector('small');
        const value = price.querySelector('strong');
        const unit = price.matches('.room-product__price--value') ? price.querySelector(':scope > span') : null;
        [label, value, unit].filter(Boolean).forEach(node => priceTarget.append(node.cloneNode(true)));
      }
      const abort = new AbortController();
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!root.isConnected) return;
        const rect = primary.getBoundingClientRect();
        const show = rect.height > 0 && rect.bottom <= 0;
        if (!show && bar.contains(document.activeElement)) primary.focus({preventScroll: true});
        bar.hidden = !show;
        if (show) document.body.style.setProperty('--pmw-offer-sticky-height', `${bar.offsetHeight}px`);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, {passive: true, signal: abort.signal});
      window.addEventListener('resize', schedule, {passive: true, signal: abort.signal});
      const observer = new ResizeObserver(schedule);
      observer.observe(root);
      observer.observe(bar);
      document.body.classList.add('pmw-has-offer-sticky');
      root.dataset.pmwOfferReady = 'true';
      instances.set(root, () => { abort.abort(); observer.disconnect(); cancelAnimationFrame(frame); bar.hidden = true; });
      schedule();
      document.fonts?.ready.then(schedule);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => {
      if (event.target.contains(root)) { dispose(); instances.delete(root); }
    });
    if (!instances.size) document.body.classList.remove('pmw-has-offer-sticky');
  });
})();
